import apiService from '@/services/apiService';

const actions = {
  getAllClaimExcessWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-excess/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postApproveClaimExcess({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/claim-excess/approve-claim/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getClaimExcessRejectReason({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/claim-excess/reject-reason')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postRejectClaimExcess({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`cx/claim-excess/reject-claim/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;